// This is used in both API calls and clientside phone number validation with libphonenumber

import { CountryCode } from "libphonenumber-js/types";
import type { PossibleGatsbyCountry } from "../live-sites";

const COUNTRY = process.env.GATSBY_COUNTRY as PossibleGatsbyCountry;

const subdomainToCountryCode: Record<PossibleGatsbyCountry, CountryCode> = {
  uk: "GB",
  us: "US",
  au: "AU",
  ca: "CA",
  za: "ZA",
  in: "IN",
  ie: "IE",
  fr: "FR",
  de: "DE",
  nl: "NL",
  it: "IT",
  nz: "NZ",
  ae: "AE",
  sg: "SG",
  es: "ES",
  br: "BR",
  mx: "MX",
};

export default function getCountryCodeFromCountry() {
  const countryCode = subdomainToCountryCode[COUNTRY];

  if (!countryCode) {
    throw new Error(`no countryCode for ${COUNTRY}`);
  }

  return countryCode;
}
